// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module__wrapper___3Ri0z","hidden":"style-module__hidden___19aIr"};